import React from "react";

export interface OverviewCardData {
  label: string;
  value: string | number;
  icon: React.ComponentType<{ className?: string }>;
}

interface OverviewCardsGridProps {
  cards: OverviewCardData[];
}

export const OverviewCard: React.FC<OverviewCardData> = ({ label, value, icon: Icon }) => {
  return (
    <div className="bg-white border border-slate-200/80 rounded-xl p-3 shadow-sm flex items-center gap-4">
      <div className="w-9 h-9 rounded-xl bg-primary text-white flex items-center justify-center">
        <Icon className="w-4 h-4" />
      </div>
      <div>
        <div className="text-xs font-semibold text-slate-500">{label}:</div>
        <div className="text-xl font-bold text-slate-900">{value}</div>
      </div>
    </div>
  );
};

export const OverviewCardsGrid: React.FC<OverviewCardsGridProps> = ({ cards }) => {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-5 gap-4">
        {cards.map((card, index) => (
          <OverviewCard
            key={index}
            label={card.label}
            value={card.value}
            icon={card.icon}
          />
        ))}
      </div>
    </div>
  );
};

export default OverviewCardsGrid;
